var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBody2Left1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 804.09 717.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-body-1 {\n        fill: #d61800;\n      }\n\n      .cls-body-2 {\n        fill: var(--custom-color, #fa) !important;\n      }\n\n      .cls-skin-color {\n        fill: var(--custom-skin-color, #dd8f5f) !important;\n      }\n\n      .cls-body-4 {\n        fill: #fff;\n      }\n\n      .cls-body-5 {\n        fill: #0f8d4e;\n      }\n\n      .cls-body-6 {\n        fill: #4b3e50;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-skin-color",
    d: "M325.33,147.76l54.99-79.96,244.26,168c9.07-7.63,19.52-13.93,31.21-18.41,56.3-21.58,119.44,6.56,141.02,62.86,21.58,56.3-6.56,119.44-62.86,141.02-56.3,21.58-119.44-6.56-141.02-62.86-3.96-10.34-6.23-20.9-6.98-31.4l-260.63-179.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-body-2",
    d: "M426.06,229.29c-30.88-1.42-66.3-15.17-97.71-40.45-58.62-47.18-81.07-116.57-50.15-155.01,30.93-38.43,103.52-31.35,162.15,15.83,31.41,25.28,52.42,56.94,60.42,86.8l-74.71,92.83Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-body-4",
    cx: 453.63,
    cy: 629.92,
    rx: 100.08,
    ry: 78.12,
    transform: "translate(-300.06 444.12) rotate(-40.39)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-body-1",
    cx: 452.17,
    cy: 617.22,
    rx: 100.08,
    ry: 78.12,
    transform: "translate(-292.18 440.14) rotate(-40.39)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-body-4",
    cx: 188.98,
    cy: 573.69,
    rx: 100.08,
    ry: 78.12,
    transform: "translate(-275.95 188.1) rotate(-32.1)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-body-1",
    cx: 189.36,
    cy: 560.91,
    rx: 100.08,
    ry: 78.12,
    transform: "translate(-269.1 186.35) rotate(-32.1)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-body-5",
    d: "M227.47,474.11l-1.09,28.46c-.53,13.75-22.86,24.06-49.87,23.02-27.02-1.04-48.49-13.03-47.96-26.78l1.09-28.46,97.83,3.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-body-5",
    d: "M395.33,532.51l7.81,27.39c3.77,13.24,27.91,17.96,53.91,10.55,26-7.41,44.02-24.15,40.25-37.39l-7.81-27.39-94.16,26.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-body-6",
    d: "M264.3,340.76s34.32,43.45,35.49,105.84c0,0-134.18,77.1-226.95,26.18l-6.72-33.46,3.41-88.86,194.77-9.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-body-6",
    d: "M297.41,371.64s-22.95,85.77-9.3,146.66c0,0,148.63,43.11,226.68-28.35h0c-.93-22.67-4.16-45.19-9.66-67.21l-20.76-83.21-186.97,32.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-body-2",
    d: "M401.37,393.8c102.15-32.04,175.2-98.97,185.19-177.98l.02-.18c1.12-8.93,1.22-17.94.29-26.89l-2-19.27c-1.1.08-2.19.15-3.27.21-40.93,2.15-77.9-21.93-89.48-57.22L455.23,0h-53.86s-136.84,0-136.84,0h-53.86s-36.89,112.47-36.89,112.47c-11.57,35.29-48.55,59.37-89.48,57.22-1.08-.06-2.17-.13-3.27-.21l-1.99,19.09c-.94,9.07-.85,18.2.29,27.26h0c6.06,47.97,35.37,91.49,80.33,125.44,52.63,39.76,119.9,60.06,188.7,59.69,19.65-.11,38.93-1.95,53-7.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-skin-color",
    d: "M369.36,71.99l63.28,73.57-224.76,193.32c5.07,10.72,8.48,22.43,9.84,34.88,6.51,59.94-36.82,113.81-96.76,120.32-59.94,6.51-113.81-36.81-120.32-96.76-6.51-59.94,36.82-113.81,96.76-120.32,11-1.19,21.8-.7,32.14,1.26l239.82-206.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-body-2",
    d: "M264.83,148.58c9.25-29.49,31.58-60.23,64.04-84.16,60.57-44.65,133.4-48.65,162.67-8.94,29.27,39.71,3.9,108.09-56.67,152.74-32.46,23.93-68.43,36.16-99.34,36.27l-70.7-95.92Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBody2Left1);
export default __webpack_public_path__ + "static/media/body2-left1.d2ea9639820e5e4789e590d5cb25ff07.svg";
export { ForwardRef as ReactComponent };